import * as unhandledRejection from "browser-unhandled-rejection";

unhandledRejection.auto();
